import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { Badge } from "@mui/material";
import helpers from "utils/helpers";

const NotificationList = ({
  notifications,
  markAsRead,
  navigate,
  hoveredNotificationId,
  setHoveredNotificationId,
  t,
  maxItems = null,
}) => {
  const displayedNotifications = maxItems
    ? notifications.slice(0, maxItems)
    : notifications;

  return (
    <ListGroup flush>
      {displayedNotifications.map((notification) => (
        <ListGroupItem
          key={notification._id}
          tag="div"
          onMouseEnter={() =>
            setHoveredNotificationId &&
            setHoveredNotificationId(notification._id)
          }
          onMouseLeave={() =>
            setHoveredNotificationId && setHoveredNotificationId(null)
          }
          className={`list-group-item-action py-3 px-4 position-relative sidenav-toggler ${
            !notification.read ? "bg-blue-50" : "bg-white"
          } hover:bg-blue-100 transition`}
          onClick={() =>
            helpers.handleOpenNotification({
              notification,
              navigate,
              markAsRead,
            })
          }
        >
          <div className="d-flex justify-content-between gap-3 flex-wrap">
            <div className="d-flex gap-3 flex-70">
              <div className="flex-shrink-0 mr-3">
                {helpers.getNotificationIcon(notification.type)}
              </div>

              <div className="flex flex-col truncate">
                <h5
                  className={`mb-0 truncate text-base subtitle-large ${
                    !notification.read ? "font-bold text-[#111]" : "text-gray-800"
                  }`}
                >
                  {notification.subject ||
                    notification.sender?.name ||
                    t("page.notifications.untitled", "Notification")}
                </h5>

                {notification.subtitle && (
                  <small className="text-gray-500 truncate subtitle-small">
                    {notification.subtitle}
                  </small>
                )}
              </div>
            </div>

            <div className="d-flex flex-column align-items-end gap-1 flex-30">
              <div className="align-items-center">
                {!notification.read && (
                  <Badge badgeContent="!" className="custom-badge mr-3" />
                )}
                <small>{helpers.getRelativeTime(notification.createdAt, t)}</small>
              </div>

              {!notification.read &&
                hoveredNotificationId === notification._id &&
                setHoveredNotificationId && (
                  <button
                    className="btn btn-xs btn-outline-primary mt-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      markAsRead(notification._id);
                    }}
                  >
                    {t("page.notifications.markAsRead", "Mark as read")}
                  </button>
                )}
            </div>
          </div>

          {notification.description && (
            <p className="text-sm mt-2 mb-0 text-gray-700 truncate">
              {notification.description}
            </p>
          )}
        </ListGroupItem>
      ))}
    </ListGroup>
  );
};

export default NotificationList;
